import { cn } from '@/lib/utils';

interface MobileSkeletonProps {
    className?: string;
}

export function MobileSkeleton({ className }: MobileSkeletonProps) {
    return (
        <div className={cn('mobile-skeleton', className)} />
    );
}

export function NotificationSkeleton() {
    return (
        <div className="p-4 space-y-4">
            {[1, 2, 3, 4].map((i) => (
                <div key={i} className="mobile-card space-y-3">
                    <div className="flex items-center gap-3">
                        <MobileSkeleton className="h-5 w-24" />
                        <MobileSkeleton className="h-5 w-12" />
                    </div>
                    <MobileSkeleton className="h-4 w-full" />
                    <MobileSkeleton className="h-3 w-20" />
                </div>
            ))}
        </div>
    );
}
